/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect } from "react";
import { fetchSpotLegsWithSearchTerm, fetchSpotLegsV2 } from "../slices/spotLegsSlice";

import PageLayout from "./PageLayout";
import Loader from "../components/Loader";
import SpotFiltersContainer from "./SpotFiltersContainer";
import SpotLegsTable from "./SpotLegsTable";
import { isCarrier } from "../helpers/goTrackUserUtils";
import AlertBanner from "../components/common/AlertBanner";
import { useSelector, useDispatch } from "react-redux";

const GoSpotContainer = () => {
  const filters = useSelector((state) => state.spotFilters);
  const searchTerm = useSelector((state) => state.spotFilters.searchTerm);
  const isFetching = useSelector((state) => state.spotLegs.isFetching);
  const user = useSelector((state) => state.goTrackUser.goTrackUser);
  const currentPage = filters.currentPage;
  const dispatch = useDispatch();
  const isCarrierUser = isCarrier(user.roles);

  const handleSpotLegsFetch = () => {
    // Need to remove this line when combined with filters
    // Remove fetchSpotLegsWithSearchTerm since it will no longer be needed
    if (filters.searchTerm) {
      dispatch(fetchSpotLegsWithSearchTerm(currentPage));
    } else {
      dispatch(fetchSpotLegsV2(filters));
    }
  };

  useEffect(() => {
    handleSpotLegsFetch();
  }, [filters]);

  return (
    <PageLayout
      pageTitle="RouteConnect™ Available Routes"
      documentTitle="RouteConnect™ - Available Routes"
      data-testid="gospot"
    >
      {isCarrierUser && (
        <AlertBanner message="Please click on an available leg, review all notes, and use the Claim feature or call 1-800-332-9735 x3 to initiate the booking process!" />
      )}
      {(!searchTerm) && (
        <SpotFiltersContainer handleRefresh={handleSpotLegsFetch} />
      )}
      {isFetching && <Loader />}
      <SpotLegsTable />
    </PageLayout>
  );
};

export default GoSpotContainer;
